import React from "react";
import styles from "./Services.module.scss";
import ParticlesLayer from '../../components/ParticlesLayer';
import SlidesServices from '../../components/SlidesServices';
import Map from '../../components/MapServices';
const Services = () => {
    
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.particles}>
          <ParticlesLayer type={'services'}/>
        </div>
        <div className={styles.slides}>
          <SlidesServices />
        </div>
        <div className={styles.map}>
          <Map />
        </div>
      </div>
    </>
  );

}

export default Services;
